import styled from "styled-components";

export const ActivityCertificateContainerStyled = styled.div`
  padding: 20px 20px 40px 20px;
  .certificate_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .activity_img_wrap {
      margin-bottom: 22px;
      border-radius: 12px;
      overflow: hidden;
    }
    .step_desc {
      margin-bottom: 20px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      line-height: 1.5;
    }
    .step_title {
      margin-bottom: 16px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
    }
    .confirm_box {
      margin-bottom: 24px;
      padding: 20px;
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      border-radius: 12px;
      .cb_item {
        margin-bottom: 14px;
        &:last-child {
          margin-bottom: 0px;
        }
        .cb_label {
          color: ${({ theme }) => theme.COLORS.GRAY_2};
          font-size: ${({ theme }) => theme.FONT.SIZE.S14};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
        }
        .cb_value {
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S18};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
          word-break: break-all;
        }
      }
    }
    .result_section {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 24px 0;
      .result_icon {
        margin-bottom: 20px;
      }
      .result_title {
        margin-bottom: 8px;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S21};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      }
      .result_sub_title {
        margin-bottom: 8px;
        color: ${({ theme }) => theme.COLORS.GRAY_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
        line-height: 1.5;
      }
    }
    .btn_wrap {
      width: 100%;
      margin-bottom: 12px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 32px 20px 40px 20px;
  }
`;
